<template>
  <div v-if="lb" class="leaderboard">
    <h2 class="mb-0">{{ lb.title }}</h2>
    <div class="table-responsive">
      <table class="table table-borderless table-striped">
        <thead>
          <tr>
            <th>
              {{ leaderboardContestantHeader }}
            </th>
            <th
              v-for="(col, i) in lb.leaderboard_columns"
              :key="i"
              :data-sort="col.name"
              class="text-nowrap"
              :class="{ 'gg-branding-supporting': isSortColumn(col) }"
              @click="changeSort"
            >
              {{ col.label }}
              <span v-if="isSortColumn(col)" v-html="sortIcon" class="sort-icon gg-branding-supporting"></span>
            </th>
          </tr>
        </thead>
        <transition-group name="results-list" tag="tbody">
          <LeaderboardRow v-for="(result, i) in results" :key="result.id" :entryIndex="i" :result="result" />
        </transition-group>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import LeaderboardRow from './LeaderboardRow.vue'

export default {
  name: 'Leaderboard',
  components: {
    LeaderboardRow,
  },
  props: {
    lb: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      results: null,
      sortColumn: null,
      sortDirection: null,
    }
  },
  computed: {
    ...mapGetters(['custom']),
    leaderboardContestantHeader () {
      return this.lb.contestant_header
    },
  },
  mounted () {
    // TODO remove sort OR assignment after all dogs use_new_leaderboards
    this.sortColumn = this.lb.initial_sort_column
    this.sortDirection = this.lb.initial_sort_asc ? 'asc' : 'desc';
    this.sortIcon = this.sortDirection === 'asc' ? ' &#9650;' : ' &#9660;';
    this.loadLbResults();
    setInterval( () => this.loadLbResults(), 30000);
  },
  methods: {
    changeSort (e) {
      const clickedColumn = e.target.dataset.sort || e.target.parentElement.dataset.sort
      if (this.sortColumn === clickedColumn && this.sortDirection === 'desc') {
        this.sortDirection = 'asc';
      } else {
        this.sortDirection = 'desc';
      }
      this.sortColumn = clickedColumn;
      this.sortIcon = this.sortDirection === 'asc' ? ' &#9650;' : ' &#9660;';
      this.loadLbResults();
    },
    isSortColumn (col) {
      return col.name === this.sortColumn
    },
    loadLbResults () {
      const url = `${this.$store.state.ggLeaderboardsApiUrl}v1/leaderboards/${this.lb.id}/results`;
      const params = {
        dog_id: this.$store.state.dog.id,
        per_page: 10,
        sort_column: this.sortColumn,
        sort_direction: this.sortDirection,
        with: 'measurable'
      };
      axios
        .get(url, { params: params })
        .then(response => this.results = response.data.results);
    },
  }
}
</script>

<style scoped>
th[data-sort] {
  cursor: pointer;
}
th:first-child {
  text-align: left;
}
.table-responsive {
  overflow-y: hidden;
}
.results-list-move {
  transition: transform .5s ease;
}
.results-list-enter-active {
  transition: all .5s ease;
}
.results-list-leave {
  display: none;
}
.results-list-leave-active {
  display: none;
}
.results-list-enter {
  opacity: 0;
  transform: translateY(30px);
}
</style>

<style lang="scss">
@media screen and (min-width: 768px) {
  .leaderboard {
    overflow-y: hidden;
    height: 100%;

    h2 {
      font-size: 4vh;
    }

    .table td, .table th {
      padding-top: 0;
      padding-bottom: 0;
    }

    .table tr {
      line-height: 5.6vh;
    }
  }
}
</style>
